// components/meta/GTM.jsx
import { useEffect } from 'react';
import { getOptions } from "@/api";

const GTM = () => {
    useEffect(() => {
        const loadGtm = async () => {
            try {
                const options = await getOptions();
                const gtmId = options?.google_tag_manager || "";

                // Inject the Google Tag Manager script
                (function(w, d, s, l, i) {
                    w[l] = w[l] || [];
                    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
                    const f = d.getElementsByTagName(s)[0],
                        j = d.createElement(s),
                        dl = l !== 'dataLayer' ? '&l=' + l : '';
                    j.async = true;
                    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                    f.parentNode.insertBefore(j, f);
                })(window, document, 'script', 'dataLayer', gtmId);
            } catch (error) {
                console.error("Failed to fetch GTM options:", error);
            }
        };

        loadGtm();
    }, []);

    return null; // No visual output
};

export default GTM;
